import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { Stack, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";

const PrivacyComponent = ({ ...props }) => {
  return (
    <Stack
      direction={"row"}
      justifyContent={"flex-end"}
      bgcolor={"#fff"}
      width={"fit-content"}
      ml={"auto"}
      p={1}
      alignItems={"center"}
      spacing={1}
      borderRadius={2}
      {...props}
    >
      <Image src={IMAGES.shield} alt="Secure shield" height={20} width={20} />
      <Typography color={WEB_COLORS.primary} fontSize={14}>
        Your privacy is our priority
      </Typography>
    </Stack>
  );
};

export default PrivacyComponent;
